<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span>Summary Payment Details</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Transaction Date">
              <a-input v-model.trim="transactionDate" disabled />
            </base-input>
          </div>
        </div>

        <div class="row" v-if="transactionId">
          <div class="col">
            <base-input label="Transaction ID">
              <a-input
                v-model="formData.trans_id"
                placeholder="Auto-generated"
                disabled
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Selling Type">
              <a-input v-model="sellingTypeName" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Site">
              <a-input v-model="siteName" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Employee" v-if="isLostCard">
              <a-input v-model="formData.recruiter" disabled />
            </base-input>
            <base-input label="Recruiter" v-else>
              <a-input v-model="formData.recruiter" disabled />
            </base-input>
          </div>
        </div>

        <br />

        <div class="row">
          <div class="col">
            <base-input label="Card Type">
              <a-input v-model="cardTypeName" disabled />
            </base-input>
          </div>
        </div>

        <div class="row" v-if="!isLostCard">
          <div class="col">
            <base-input label="Member Name">
              <a-input v-model="formData.printed_name" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Card Number">
              <a-input v-model="formData.card_number" disabled />
            </base-input>
          </div>
        </div>

        <br />

        <div class="row">
          <div class="col">
            <base-input label="Price">
              <a-input v-model="formData.price" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Payment Option">
              <a-input v-model="paymentTypeName" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Remarks">
              <a-input v-model="formData.remarks" disabled />
            </base-input>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <base-input label="Amount Tendered">
              <a-input v-model="formData.amount_tendered" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Change">
              <a-input v-model="amountTenderedChange" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Transaction Status">
              <a-input v-model="formData.transaction_status" disabled />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                v-if="formData.trans_id !== null && viewMode"
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer(false)"
              >
                <span> Cancel </span>
              </b-button>

              <b-button
                v-else-if="formData.trans_id !== null && !viewMode"
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer(true)"
              >
                <span> Close </span>
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <div
                  v-if="
                    formData.trans_id !== null &&
                    formData.transaction_status === 'PAID'
                  "
                >
                  <a-spin :spinning="formSubmitting">
                    <b-button
                      size="sm"
                      variant="primary"
                      @click.prevent="showConfirmVoidModal"
                      :disabled="!allowVoid"
                    >
                      Void Transaction
                    </b-button>
                  </a-spin>
                </div>
              </template>
            </div>

            <div class="col-auto">
              <template>
                <div v-if="formData.trans_id !== null">
                  <a-spin :spinning="formSubmitting">
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click.prevent="openModal"
                    >
                      {{ printLabel }}
                    </b-button>
                  </a-spin>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>

    <a-modal v-model="confirmVoidModal" title="Voiding of transaction">
      <form @submit.prevent class="text-center">
        <p>
          Are you sure you want to void this transaction? This will remove card
          assignment from member.
        </p>
        <div class="row">
          <div class="col-3">Void Reason:</div>
          <div class="col-9">
            <a-select v-model="adjustment_reason_type_id">
              <a-select-option
                v-for="adjustmentReasonType in options.adjustmentReasonTypes"
                :key="'ART' + adjustmentReasonType.id"
                :value="adjustmentReasonType.id"
              >
                {{ adjustmentReasonType.name }}
              </a-select-option>
            </a-select>
            <div v-if="$v.adjustment_reason_type_id.$dirty" class="text-danger">
              <div class="error" v-if="!$v.adjustment_reason_type_id.required">
                Field is required
              </div>
            </div>
          </div>
        </div>
      </form>

      <template slot="footer">
        <a-button key="back" @click="closeConfirmVoidModal"> No</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="formSubmitting"
          @click="voidTransaction"
        >
          Yes
        </a-button>
      </template>
    </a-modal>

    <a-modal class="receipt-modal" v-model="printReceiptModal" width="464px">
      <div class="py-2">
        <div class="text-left" id="printable-content">
          <span>{{ printLabelModal }}</span> <br />
          <span>Transaction Date / Time: {{ transactionDateAndTime }}</span>
          <br />
          <span>Transaction Number: {{ formData.trans_id }}</span> <br />
          <span>Branch: {{ siteName }}</span> <br />
          <span>Card number: {{ formData.card_number }}</span> <br />
          <span>Type: {{ sellingTypeName }}</span> <br />
          <span>Payment Type: {{ paymentTypeName }}</span> <br />
          <span>Price: ₱{{ parseFloat(formData.price).toFixed(2) }}</span>
          <br />
          <span>Status: {{ formData.transaction_status }}</span> <br />
          <span>Transacted By: {{ transacted_by }}</span>
          <br />
          <br />
          <span>THIS DOCUMENT IS NOT VALID FOR CLAIM OF INPUT TAX</span>
          <br />
          <span>Telephone # {{ sitePhone }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<style>
.receipt-modal .ant-modal-header,
.receipt-modal .ant-modal-close,
.receipt-modal .ant-modal-footer {
  display: none !important;
}
.dotted-line {
  background-image: linear-gradient(
    to right,
    black 33%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 3px 1px;
  background-repeat: repeat-x;
}
@media print {
  @page {
    size: 80mm 90mm; /* Set the paper size */
    margin: 0; /* Remove default margins */
  }
  body {
    margin: 0; /* Reset margins for body */
    padding: 0;
    overflow: hidden;
  }
  body * {
    visibility: hidden;
  }

  .ant-modal,
  .ant-modal * {
    visibility: visible;
  }

  .ant-modal-header,
  .ant-modal-close,
  .ant-modal-footer {
    display: none !important;
  }
  .dotted-line {
    display: none;
  }
}
</style>
<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../../controllers/httpRequest';
import printJS from 'print-js';
import secureStorage from '@/controllers/secureStorage';

let TIMEZONE = process.env.VUE_APP_TIMEZONE;

if (!TIMEZONE) {
  TIMEZONE = 'Asia/Singapore';
}

export default {
  name: 'CardPaymentDetailForm',
  props: {
    viewMode: Boolean,
    cardTransactionData: Object,
    cardFormData: Object
  },
  data() {
    return {
      formSubmitting: false,
      allowVoidValue: false,
      allowVoidTimeout: null,
      adjustment_reason_type_id: null,
      confirmVoidModal: false,
      printReceiptModal: false,
      isLostCard: false,
      cardStatusCode: null,
      transacted_by: secureStorage.getItem('username'),
      printLabel: 'Print Receipt',
      printLabelModal: '',
      printed: false,
      formDetails: {
        sellingType: null,
        site: null,
        cardType: null,
        paymentType: null
      },
      formData: {
        trans_id: this.cardTransactionData.trans_id,
        site_id: this.cardTransactionData.site_id,
        member_id: this.cardTransactionData.member_id,
        membership_program_id: this.cardTransactionData.membership_program_id,
        membership_level_id: this.cardTransactionData.membership_level_id,
        card_id: this.cardTransactionData.card_id,
        card_number: this.cardTransactionData.card_number,
        printed_name: this.cardTransactionData.printed_name,
        card_selling_type_id: this.cardTransactionData.card_selling_type_id,
        price: this.cardTransactionData.price,
        amount_tendered: this.cardTransactionData.amount_tendered,
        payment_type_id: this.cardTransactionData.payment_type_id,
        transaction_type: this.cardTransactionData.transaction_type,
        transaction_date: this.cardTransactionData.transaction_date,
        transaction_status: this.cardTransactionData.transaction_status,
        recruiter: this.cardTransactionData.recruiter,
        remarks: this.cardTransactionData.remarks
      },
      options: {
        adjustmentReasonTypes: []
      }
    };
  },

  validations: {
    adjustment_reason_type_id: { required }
  },

  methods: {
    closeDrawer(successTransaction = false) {
      this.$emit('closeDrawer', successTransaction);
    },
    onPrintDialogClose() {
      if (this.printReceiptModal) {
        this.updatePrintCount();
      }
    },
    openModal() {
      this.printReceiptModal = true;
      this.$nextTick(() => {
        printJS({
          printable: 'printable-content', // ID or class of the content to print
          type: 'html',
          maxWidth: '100%',
          targetStyles: ['*'],
          font_size: '12px;',
          onPrintDialogClose: this.onPrintDialogClose // Attach the callback
        });
      });
    },
    async updatePrintCount() {
      this.printed = true;
      await HTTPRequest.putRequest(
        '/api/v1/card_transactions/' +
          this.cardTransactionData.id +
          '/printed_counter',
        {
          card_transaction: {
            adjustment_reason_type_id: this.adjustment_reason_type_id
          }
        }
      );
    },
    confirmPayment() {
      const _self = this;
      this.$confirm({
        title:
          "Do you want to proceed with the payment? Click 'Yes' to confirm transaction and print the receipt.",
        okText: 'Yes',
        onOk() {
          _self.confirmCardActivation();
        },
        onCancel() {}
      });
    },

    clearForm() {
      this.formData = {
        trans_id: null,
        site_id: null,
        member_id: null,
        membership_program_id: null,
        membership_level_id: null,
        card_id: null,
        card_number: null,
        printed_name: null,
        card_selling_type_id: null,
        price: null,
        amount_tendered: null,
        payment_type_id: null,
        transaction_type: null,
        transaction_date: null,
        transaction_status: null,
        recruiter: null,
        remarks: null
      };
    },

    setFormData(data) {
      if (data) {
        this.transacted_by = data?.createdByUser?.user_name;
        this.formData = {
          trans_id: data.trans_id,
          site_id: data.site_id,
          member_id: data.member_id,
          membership_program_id: data.membership_program_id,
          membership_level_id: data.membership_level_id,
          card_id: data.card_id,
          card_number: data.card_number,
          printed_name: data.printed_name,
          card_selling_type_id: data.card_selling_type_id,
          price: data.price,
          amount_tendered: data.amount_tendered,
          payment_type_id: data.payment_type_id,
          transaction_type: data.transaction_type,
          transaction_date: data.transaction_date,
          transaction_status: data.transaction_status,
          recruiter: data.recruiter,
          remarks: data.remarks
        };
      }
    },

    showConfirmVoidModal() {
      this.confirmVoidModal = true;
    },

    closeConfirmVoidModal() {
      this.$v.adjustment_reason_type_id.$reset();
      this.adjustment_reason_type_id = null;
      this.confirmVoidModal = false;
    },

    async voidTransaction() {
      this.$v.adjustment_reason_type_id.$touch();

      if (!this.$v.adjustment_reason_type_id.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/card_transactions/' + this.cardTransactionData.id + '/void',
          {
            card_transaction: {
              adjustment_reason_type_id: this.adjustment_reason_type_id
            }
          }
        );

        if (response.message === 'Success') {
          this.closeConfirmVoidModal();
          await new Promise((r) => setTimeout(r, 300));
          this.closeDrawer(true);
          this.$notification.success({
            message: 'Success',
            description: 'Transaction has been voided'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: response.error
          });
        }

        this.formSubmitting = false;
      }
    },

    /**
     * Methods for getting data for specific id
     */
    async getSellingType() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/card_selling_types/' +
          this.cardTransactionData.card_selling_type_id
      );
      this.formDetails.sellingType = data;
      let transactionTypes = JSON.parse(data.transaction_types);
      this.isLostCard = !!transactionTypes.includes('LOST_CARD');
    },
    async getSite() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/sites/' + this.cardTransactionData.site_id
      );
      this.formDetails.site = data;
    },
    async getCard() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/cards/' + this.cardTransactionData.card_id + '/card_type'
      );
      this.formDetails.cardType = data.cardType;
    },

    updateAllowVoidValue() {
      console.log('updateAllowVoidValue has run');
      if (
        this.cardTransactionData &&
        this.cardTransactionData.transaction_date
      ) {
        const today = moment().tz(TIMEZONE).startOf('day');
        const cardTransactionDate = moment
          .tz(this.formData.transaction_date, moment.tz.guess())
          .utc()
          .startOf('day');
        console.log('cardTransactionDate', cardTransactionDate);
        this.allowVoidValue = today.isSame(cardTransactionDate, 'day');
      } else {
        console.log('false');
        this.allowVoidValue = false;
      }
    },
    async getPaymentType() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/payment_types/' + this.cardTransactionData.payment_type_id
      );
      this.formDetails.paymentType = data;
    },

    async getAdjustmentReasonTypes() {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${this.cardTransactionData.membership_program_id}/adjustment_reason_types?category=CARD_SELLING`
      );

      this.transacted_by = this.cardTransactionData?.createdByUser?.user_name;
      if (!this.viewMode) {
        setTimeout(() => {
          this.openModal();
        }, 300);
      }
      setTimeout(() => {
        this.updateAllowVoidValue();
      }, 400);
      this.options.adjustmentReasonTypes = data;
    }
  },
  mounted: function () {
    this.transacted_by = secureStorage.getItem('username');
  },
  computed: {
    sellingTypeName() {
      return this.formDetails?.sellingType?.name ?? null;
    },
    siteName() {
      return this.formDetails?.site?.name ?? null;
    },
    sitePhone() {
      return this.formDetails?.site?.contact_no ?? null;
    },
    cardTypeName() {
      return this.formDetails?.cardType?.name ?? null;
    },
    paymentTypeName() {
      return this.formDetails?.paymentType?.name ?? null;
    },
    transactionId() {
      return this.cardTransactionData?.trans_id ?? null;
    },
    transactionDate() {
      return moment
        .tz(this.formData.transaction_date, moment.tz.guess())
        .utc()
        .format('MM/DD/YYYY');
    },
    transactionDateAndTime() {
      return moment
        .tz(this.formData.transaction_date, moment.tz.guess())
        .utc()
        .format('MM/DD/YYYY hh:mm A');
    },
    amountTenderedChange() {
      return this.cardTransactionData
        ? (
            this.cardTransactionData.amount_tendered -
            this.cardTransactionData.price
          ).toFixed(2)
        : 0.0;
    },

    allowVoid() {
      return this.allowVoidValue;
    }
  },

  created() {
    this.printed = this.cardTransactionData?.print ? true : false;
    this.printLabel = this.cardTransactionData?.print
      ? 'Reprint Receipt'
      : 'Print Receipt';

    this.printLabelModal = this.cardTransactionData?.print
      ? 'REPRINT (COPY ONLY)'
      : '';
    this.getSellingType();
    this.getSite();
    this.getCard();
    this.getPaymentType();

    if (
      this.cardTransactionData?.trans_id !== null &&
      this.cardTransactionData?.transaction_status === 'PAID'
    ) {
      this.getAdjustmentReasonTypes();
    }
  },

  watch: {
    cardTransactionData: function (data) {
      if (data !== null) {
        this.getSellingType();
        this.getSite();
        this.getCard();
        this.getPaymentType();
        this.setFormData(data);

        if (data.trans_id !== null && data.transaction_status === 'PAID') {
          this.getAdjustmentReasonTypes();
        }
      }
    },
    'cardTransactionData.transaction_date': function () {
      clearTimeout(this.allowVoidTimeout);
      this.allowVoidTimeout = setTimeout(() => {
        this.updateAllowVoidValue();
      }, 300);
    },
    printReceiptModal(newValue) {
      if (!newValue) {
        if (this.printed) {
          this.printLabel = 'Reprint Receipt';
          this.printLabelModal = 'REPRINT (COPY ONLY)';
        } else {
          this.printLabel = 'Print Receipt';
          this.printLabelModal = '';
        }
      } else {
        this.printLabel = 'Print Receipt';
        this.printLabelModal = '';
      }
    }
  }
};
</script>
